/**
 * Centralized query keys for Pricing Rule queries
 * 
 * Ensures consistency across all Pricing Rule-related queries and mutations.
 * Prevents cache key mismatches that cause snap-back issues.
 */

export const pricingRuleQueryKeys = {
  /**
   * Query key for a single pricing rule detail
   */
  detail: (name: string) => ["pricing-rule", name] as const,
  
  /**
   * Query key for pricing rule list
   */
  list: () => ["pricing-rules", "list"] as const,
  
  /**
   * Query key for pricing rules filtered by item code
   */
  forItem: (itemCode: string, pageIndex: number, pageSize: number) => 
    ["pricing-rules-for-item", itemCode, pageIndex, pageSize] as const,
  
  /**
   * Query key for all pricing rule queries (for invalidation)
   */
  all: () => ["pricing-rule"] as const,
};
